import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-black">
      <div className="relative w-full aspect-[2400/1028] max-h-[720px]">
        <img
          src="https://www.cisco.com/content/dam/cisco-cdc/site/images/heroes/homepage/cisco-live-2026-melbourne-2400x1028.jpg"
          alt="Cisco Live 2026 Melbourne"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

        <div className="relative z-10 h-full flex items-center">
          <div className="px-6 lg:px-16 max-w-3xl text-white fade-up">
            <p className="text-sm font-semibold tracking-widest uppercase text-[#00bceb] mb-4">Cisco Live 2026 • Melbourne</p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Register for Cisco Live
            </h1>
            <p className="text-lg md:text-xl text-gray-100 mb-8 leading-relaxed">
              Gain insights and hands-on experience you need to confidently connect, secure, and excel in today's AI-powered landscape.
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 bg-white text-[#0d274d] hover:bg-[#00bceb] hover:text-white transition-colors px-6 py-3 font-semibold"
            >
              Register now
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      {/* Quick links strip */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-x-8 gap-y-3 px-4 py-4 text-sm">
          {['Downloads', 'Certifications', 'Cisco Validated', 'Training', 'Community', 'Support'].map((t) => (
            <a key={t} href="#" className="text-[#0d274d] hover:text-[#00bceb] hover:underline font-medium">{t}</a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
